{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Создать новую команду",
    "HEADER": "Команды",
    "LOADING": "Получение команд",
    "DESCRIPTION": "Команды позволяют вам организовывать агентов в группы, основываясь на их обязанностях. Агент может состоять в нескольких командах. При совместной работе вы можете назначить разговоры конкретным командам.",
    "LEARN_MORE": "Узнать больше о командах",
    "LIST": {
      "404": "В этом аккаунте нет ни одной команды.",
      "EDIT_TEAM": "Редактировать команду",
      "NONE": "Ничего"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Создать новую команду",
        "DESC": "Добавьте название и описание в вашу новую команду."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Добавить операторов в команду",
        "TITLE": "Добавить операторов в команду - {teamName}",
        "DESC": "Добавьте операторов в вашу только что созданную команду. Это позволит вам сотрудничать как команде при разговорах, получать уведомления о новых событиях в том же разговоре."
      },
      "WIZARD_CREATE": {
        "TITLE": "Создать",
        "BODY": "Создайте новую команду операторов."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Добавить операторов",
        "BODY": "Добавить операторов в команду."
      },
      "WIZARD_FINISH": {
        "TITLE": "Завершить",
        "BODY": "Все готово!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Редактировать данные вашей команды",
        "DESC": "Редактировать название и описание для вашей команды.",
        "BUTTON_TEXT": "Обновить команду"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Обновить операторов в команде",
        "TITLE": "Добавить операторов в команду - {teamName}",
        "DESC": "Добавьте операторов в вашу только что созданную команду. Все добавленные операторы будут уведомлены, когда беседа будет назначена этой команде."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Информация о команде",
        "ROUTE": "settings_teams_edit",
        "BODY": "Изменить имя, описание и другие сведения."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Редактировать операторов",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Управляйте операторами вашей команды."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Завершить",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Все готово!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Не удалось сохранить информацию о команде. Попробуйте еще раз."
    },
    "AGENTS": {
      "AGENT": "Оператор",
      "EMAIL": "Email",
      "BUTTON_TEXT": "Добавить операторов",
      "ADD_AGENTS": "Добавление операторов в вашу команду...",
      "SELECT": "выбрать",
      "SELECT_ALL": "выбрать всех операторов",
      "SELECTED_COUNT": "Выбрано {selected} из {total} операторов."
    },
    "ADD": {
      "TITLE": "Добавить операторов в команду - {teamName}",
      "DESC": "Добавьте операторов в вашу только что созданную команду. Это позволит вам сотрудничать как команде при разговорах, получать уведомления о новых событиях в том же разговоре.",
      "SELECT": "выбрать",
      "SELECT_ALL": "выбрать всех операторов",
      "SELECTED_COUNT": "Выбрано {selected} из {total} операторов.",
      "BUTTON_TEXT": "Добавить операторов",
      "AGENT_VALIDATION_ERROR": "Выберите хотя бы одного оператора."
    },
    "FINISH": {
      "TITLE": "Ваша команда готова!",
      "MESSAGE": "Теперь вы можете сотрудничать как команда в беседах. Удачной вам поддержки",
      "BUTTON_TEXT": "Завершить"
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Команда успешно удалена.",
        "ERROR_MESSAGE": "Не удалось удалить команду. Повторите попытку."
      },
      "CONFIRM": {
        "TITLE": "Вы уверены, что хотите удалить команду?",
        "PLACE_HOLDER": "Пожалуйста, введите {teamName} для подтверждения",
        "MESSAGE": "Удаление команды снимет назначение команды из бесед, связанных с этой командой.",
        "YES": "Удалить ",
        "NO": "Отменить"
      }
    },
    "SETTINGS": "Настройки",
    "FORM": {
      "UPDATE": "Обновить команду",
      "CREATE": "Создать команду",
      "NAME": {
        "LABEL": "Название команды",
        "PLACEHOLDER": "Пример: Продажи, Поддержка клиентов"
      },
      "DESCRIPTION": {
        "LABEL": "Описание команды",
        "PLACEHOLDER": "Краткое описание этой команды."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Разрешить автоматическое назначение для этой команды."
      },
      "SUBMIT_CREATE": "Создать команду"
    }
  }
}
